import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { PaymentMethod } from "../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const usePaymentMethodLabelsMap = () => {
  const { getLabel } = useIntl();
  return React.useMemo(
    () => ({
      titleLabels: {
        [PaymentMethod.APPLE_PAY]: getLabel("checkout.payment.method.applepay"),
        [PaymentMethod.GOOGLE_PAY]: getLabel("checkout.payment.method.googlepay"),
        [PaymentMethod.BANCONTACT_CARD]: getLabel("checkout.payment.method.bancontactCard"),
        [PaymentMethod.BANCONTACT_MOBILE]: getLabel("checkout.payment.method.bancontactMobile"),
        [PaymentMethod.CASH_ON_DELIVERY]: getLabel("checkout.payment.method.cashOnDelivery"),
        [PaymentMethod.CREDITCARD]: getLabel("checkout.payment.method.creditcard"),
        [PaymentMethod.FAKE]: "Fake payment",
        [PaymentMethod.IDEAL]: getLabel("checkout.payment.method.ideal"),
        [PaymentMethod.KLARNA_ACCOUNT]: getLabel("checkout.payment.method.klarna_account"),
        [PaymentMethod.KLARNA]: getLabel("checkout.payment.method.klarna"),
        [PaymentMethod.KLARNA_PAY_NOW]: getLabel("checkout.payment.method.klarna_pay_now"),
        [PaymentMethod.MBWAY]: getLabel("checkout.payment.method.mbway"),
        [PaymentMethod.MOBILE_PAY]: getLabel("checkout.payment.method.mobilepay"),
        [PaymentMethod.MULTIBANCO]: getLabel("checkout.payment.method.multibanco"),
        [PaymentMethod.ONEY]: getLabel("checkout.payment.method.oney"),
        [PaymentMethod.PAYPAL]: getLabel("checkout.payment.method.paypal"),
        [PaymentMethod.SEPA_DIRECT_DEBIT]: getLabel("checkout.payment.method.sepadirectdebit"),
        [PaymentMethod.SWISH]: getLabel("checkout.payment.method.swish"),
        [PaymentMethod.BIZUM]: getLabel("checkout.payment.method.bizum"),
        [PaymentMethod.INVOICE]: getLabel("checkout.payment.method.invoice"),
        [PaymentMethod.TWINT]: getLabel("checkout.payment.method.twint")
      },
      actionLabels: {
        [PaymentMethod.APPLE_PAY]: getLabel("checkout.payment.method.action.applepay"),
        [PaymentMethod.GOOGLE_PAY]: getLabel("checkout.payment.method.action.googlepay"),
        [PaymentMethod.BANCONTACT_CARD]: getLabel("checkout.payment.method.action.bancontactCard"),
        [PaymentMethod.BANCONTACT_MOBILE]: getLabel(
          "checkout.payment.method.action.bancontactMobile"
        ),
        [PaymentMethod.CASH_ON_DELIVERY]: getLabel("checkout.payment.method.action.cashOnDelivery"),
        [PaymentMethod.CREDITCARD]: getLabel("checkout.payment.method.action.creditcard"),
        [PaymentMethod.FAKE]: "Fake payment",
        [PaymentMethod.IDEAL]: getLabel("checkout.payment.method.action.ideal"),
        [PaymentMethod.KLARNA_ACCOUNT]: getLabel("checkout.payment.method.action.klarna_account"),
        [PaymentMethod.KLARNA]: getLabel("checkout.payment.method.action.klarna"),
        [PaymentMethod.KLARNA_PAY_NOW]: getLabel("checkout.payment.method.action.klarna_pay_now"),
        [PaymentMethod.MBWAY]: getLabel("checkout.payment.method.action.mbway"),
        [PaymentMethod.MOBILE_PAY]: getLabel("checkout.payment.method.action.mobilepay"),
        [PaymentMethod.MULTIBANCO]: getLabel("checkout.payment.method.action.multibanco"),
        [PaymentMethod.ONEY]: getLabel("checkout.payment.method.action.oney"),
        [PaymentMethod.PAYPAL]: getLabel("checkout.payment.method.action.paypal"),
        [PaymentMethod.SEPA_DIRECT_DEBIT]: getLabel(
          "checkout.payment.method.action.sepadirectdebit"
        ),
        [PaymentMethod.SWISH]: getLabel("checkout.payment.method.action.swish"),
        [PaymentMethod.BIZUM]: getLabel("checkout.payment.method.action.bizum"),
        [PaymentMethod.INVOICE]: getLabel("checkout.payment.method.action.invoice"),
        [PaymentMethod.TWINT]: getLabel("checkout.payment.method.action.twint")
      }
    }),
    [getLabel]
  );
};
export {
  usePaymentMethodLabelsMap
};
//# sourceMappingURL=use-payment-method-labels-map.js.map
